import React from 'react';
import TextField from '@mui/material/TextField';
import { PropTypes } from 'prop-types';

// Parametros props
//id: Id del componente
//error: si da un error en la validación
//helperText: texto de ayuda
//variant: tipo de caja de texto
//label: etiqueta
//handleChange: funcion de la caja de texto

TextFieldCS.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  error: PropTypes.bool.isRequired,
  helperText: PropTypes.string,
  variant: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  multiline: PropTypes.bool,
  maxRows: PropTypes.number,
  type: PropTypes.string,
  shrink: PropTypes.bool,
  color: PropTypes.string,
  style: PropTypes.object,
};

TextFieldCS.defaultProps = {  
  id: 'Custom',
  name: 'Custom',
  error: false,
  helperText: "",
  variant: "standard",
  label:"",
  disabled: false,
  fullWidth: true,
  multiline: false,
  type: "text",
  shrink: true,
  value: '',
  color: 'primary',
  onChange: ()=>{ console.log("Escribiendo..")}
}  

function TextFieldCS(props) {
    // console.log(props);
    return (<>
              
              <TextField 
                  id={props.id} 
                  name={props.name} 
                  type={props.type}
                  fullWidth={props.fullWidth} 
                  multiline={props.multiline} 
                  maxRows={props.maxRows} 
                  error={props.error} 
                  disabled={props.disabled} 
                  label={props.label} 
                  helperText={props.helperText} 
                  variant={props.variant} 
                  onChange={props.onChange}
                  onBlur={props.onBlur}
                  onKeyUp={props.onKeyUp}
                  value={props.value}
                  color={props.color}
                  style={props.style}
                  placeholder={props.placeholder}
                  inputProps={{ maxLength: props.maxLength }}
                  rows={props.rows}
                  >
              </TextField>
              
            </>)
  }

export default React.memo(TextFieldCS);